export enum APPOINTMENT_STATUS {
  BO_CANCELLED = 'BO_CANCELLED',
  BLOCKER = 'BLOCKER',
  CUSTOMER_CANCELLED = 'CUSTOMER_CANCELLED',
  CONFIRMED = 'CONFIRMED',
  CHECKED_IN = 'CHECKED_IN',
  FULFILLED = 'FULFILLED',
  EXPIRED = 'EXPIRED',
  // Extended
  OTHER = 'OTHER',
}
